<template>
  <v-text-field
    color="primary"
    :label="label"
    :class="classField"
    :style="`font-size: ${fontSize}`"
    hide-details
    variant="underlined"
    density="compact"
    :readonly="!editable"
    :type="type"
    @update:model-value="updateValue($event)"
    @change="$emit('change')"
    @mouseover="$emit('mouseover')"
    @mouseleave="$emit('mouseleave')"
    :model-value="value"></v-text-field>
</template>
<script>
  import DirtyFieldsMixIn from "@/mixins/DirtyFieldsMixIn.vue"

  export default {
    name: "DataField",
    mixins: [DirtyFieldsMixIn],
    props: {
      parameter: { required: true },
      item: { required: true },
      type: { require: false, default: "number" },
      label: { require: true },
      show: { required: false, default: true },
      editable: { require: false, default: true },
      classField: { required: false },
      width: { default: "100%", required: false },
      fontSize: { default: "14px", required: false }
    },
    computed: {
      value () {
        var arr = this.parameter.split(".")
        let value = this.item
        for (var i = 0; i < arr.length; i++) {
          if (value)
            value = value[arr[i]]
        }
        return value
      }
    },
    methods: {
      updateValue (value) {
        this.$emit("update")
        this.$emit("set", { item: this.item, value: value !== "" ? value : null, parameter: this.parameter })
      }
    }
  }
</script>